export default function assignSessionKey(): void {
  if (!window.sessionStorage.getItem('sessionId')) {
    window.sessionStorage.setItem('sessionId', (Math.random() * 50 ** 10).toString(16));
  }
}
